"use strict";

(function (global) {
  global.toolbarWidth = 0;

  /**
  * Поиск родительской папки в переданной части URL
  * @since 5.0.0.7300
  * @function Core.toolBars.main.getSourceId
  */
  global.getSourceId = function () {
    return (new WA.URL()).getParam('opener');
  };

  /**
  * Активирует кнопку 'Удалить ссылку', если есть id родительской папки
  * @since 5.0.0.7300
  * @function Core.toolBars.main.enableDeleteButton
  */
  global.enableDeleteButton = function (toolItem) {
    //if (global.getSourceId()) toolItem.enable();
  };

  /**
  * Действие для кнопки 'Удалить ссылку' в карточках объектов
  * @since 5.0.1.1700
  * @function Core.toolBars.main.deleteLinkFromCard
  */
  global.deleteLinkFromCard = WA.TCD(function () {
    var link = new WA.Link();
    var sourceId = global.getSourceId();

    if (WA.isMobile()) {
      WA.SRV.call("/Session.asmx/DeleteLinks", { Links: [link.toLinkModel()], SourceID: sourceId, SourceType: 'FOLDER' }).done(function (res) {
        CloseJobWindow(WA.CR.getID);
      });
      return this;
    };

    var toast = new WA.CMP.notifications.Toast();

    ConfirmDelete(1, L('CONFIRM_DELETE_LINK_FROM_INBOX')).done(function () {
      WA.SRV.call("/Session.asmx/DeleteLinks", { Links: [link.toLinkModel()], SourceID: sourceId, SourceType: 'FOLDER' }).done(function (res) {
        if (res != 0) {
          var opener = window.opener;
          if (opener) {
            if (opener.WA.getLocation() === 'explorer') {
              opener.WA.CR.objectList.reload().done(function () {
                if (opener.WA.CR.folderTree)
                  opener.WA.CR.folderTree.updateNodesWithFolder(opener.WA.CR.getID());
              });
              opener.updateChkAll($('div.object_contents'), $('#chkAll'));
              opener.UpdateCopyPasteIcons();
              toast.show(L('DELETED_LINKS', res));
              opener.EnableOrDisableCheckAll();
            };
          };
        } else {
          toast.show(L("CANNOT_DELETE_LINK"));
        }

        WA.CR.window.close(this);
      });
    });

    return this;
  });

  /**
  * Действие для кнопки 'Создать папку'
  * @since 5.0.0.7300
  * @function Core.toolBars.main.createFolder
  */
  global.createFolder = function () {
    var folderId = WA.CR.getID() || FavoritesFolderID;
    var folderTab = (new WA.URL('/PleaseWait.aspx')).open();

    //IOS замораживает вкладки, которые висят в фоне, поэтому фабрики в нем отдыхают
    if (WA.ENV.os.name.toLowerCase() === 'ios') {
      (new WA.URL('/Folder.aspx')).setParam('mode', 'new').setParam('path', folderId).openIn(folderTab);
      return global;
    }

    //Во всех нормальных браузерах можно пользоваться фабриками
    WA.FC.folders.createFolder({
      'pasteToFolder': folderId
    }).done(function (folder) {
      folder.toURL().setParam('folder', folderId).openIn(folderTab);
    }).fail(function () {
      folderTab.close();
    });
    return global;
  },

  /**
  * Действие для кнопки 'Создать задачу' и 'Отравить вложением'
  * @since 5.0.0.7300
  * @function Core.toolBars.main.createTask
  */
  global.createTask = function (opt_withoutAttachments) {
    var folderId = WA.CR.getID() || OutboxFolderID;

    if (opt_withoutAttachments === true) {
      _createTask([]);
      return;
    }

    var handled = false;
    var $list = $('.object_contents.auto_load');

    if (isAllRecordsInFolderSelected() && $list.length) {
      // выделены все объекты
      // есть автоподгрузка - нужен специальный метод
      if ($list.data('component') == 'FolderContents') {
        // работаем с папкой
        handled = true;
        WA.SRV.call("/Session.asmx/GetAllLinksFolder", { FolderID: folderId }).done(function (links) {
          links = $.map(links, function (model) { return (new WA.Link()).fromLinkModel(model); });
          _createTask(links);
        });
      } else {
        // работаем с результатами поиска
        // может быть очень много найденных элементов, поэтому отправлять задачу со всеми ими не будем.
        WA.CR.inlineHint.showError(L('ERR_CANNOT_SEND_ALL_THE_SEARCH_RESULTS_AS_AN_ATTACHMENT'));
      }
    } else {
      _createTask($.map(GetSelectedObjects(), function (q) { return new WA.Link(q.id, objectKindToObjectType(q.kind), q.refcode) }));
    }

    /**
    * Непосредственно создание задачи
    * @inner
    */
    function _createTask(attachments) {
      var taskTab = (new WA.URL('/PleaseWait.aspx')).setParam("message", L("PLEASE_WAIT_TASK")).open();

      //IOS замораживает вкладки, которые висят в фоне, поэтому к сожалению фабрики в нем отдыхают
      if (WA.ENV.os.name.toLowerCase() === 'ios') {
        if (attachments.length) {
          attachments = $.map(GetSelectedObjects(), function (q) { return { ID: q.id, Kind: q.kind, CompCode: q.refcode } });
          WA.SRV.callSync("/Task.asmx/CreateTaskWithAttachments", { Attachments: attachments }).done(function (id) {
            (new WA.URL("Task.aspx?view=Card&mode=edit")).setParam("id", id).openIn(taskTab);
          });
          return;
        }
        (new WA.URL('/Task.aspx')).setParam('mode', 'new').setParam('folder', folderId).openIn(taskTab);
        return
      }

      //Во всех нормальных браузерах можно пользоваться фабриками
      WA.FC.tasks.createTask({
        attachments: attachments
      }).done(function (task) {
        task.toURL().setParam('folder', folderId).openIn(taskTab);
      }).fail(function () {
        taskTab.close();
      });
    };
  }

  /**
  * Данная функция вызывается серверной логикой, которая сначала формирует словарь buttons в следующем формате:
  * init({
  * ‘Btn1’: function() { try {
  *    DisableIfNotEq1(this);
  * } catch(ex) { ShowError(ex.message); }; },
  * ‘Btn2’: function() { try {
  *    DisableIfNotEq1(this, ‘SomeParam1’, ‘SomeParam2’)
  * } catch(ex) { ShowError(ex.message); }; },
  *});
  * затем все эти функции последовательно запускаются.
  * функции указываются в расширениях ВД, для каждой отдельной кнопки в атрибуте oninit
  *
  * @since 5.0.0.4102
  * @function Core.toolBars.main.init
  * @param {[type]} buttons [description]
  */
  global.init = function (buttons) {
    $.when(WA.ToolBarInit).done(function () {
      for (var button in buttons) {
        buttons[button].apply(WA.current.toolBar.buttons[button]);
      };
    });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Сбросить состояние тулбара. Для списка переданных кнопок заменяет состояние, для всех остальных - сбрасывает.
   *
   * @param {array} states Список состояний кнопок, которые нужно заменить.
   * @function Core.toolBars.main.reset
   */
  global.reset = function (states) {
    _.each(WA.CR.toolBar.buttons.toArray(), function (button) {
      var isDisabled, isSelected;
      var jButton = button._jObject;
      var state = _.find(states, function (el) { return el.name === button.name; });
      if (state) {
        isDisabled = state.isDisabled;
        isSelected = state.isSelected;
      }
      if (typeof isDisabled === 'undefined')
        isDisabled = jButton.data('disabled');
      if (typeof isSelected === 'undefined')
        isSelected = jButton.data('selected');

      isDisabled ? button.disable() : button.enable();
      isSelected ? button.select() : button.unSelect();
    });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Получить текущую ширину области списка объектов
  * @since 5.0.0.4104
  * @function Core.toolBars.main.getObjectListWidth
  */
  global.getObjectListWidth = function (jToolBar) {
    var addWidth = 0;
    var jAttachments = $(".attachments_td");

    if (WA.getLocation() === 'explorer') {
      // В левой колонке дерево папок.
      var jLeftColumn = $("#left_column");
      if (jLeftColumn.length != 0)
        addWidth += jLeftColumn.width();
    }

    if (jAttachments.length != 0)
      addWidth += jAttachments.width();

    return $(window).width() - 10 - addWidth;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Получить текущую ширину совокупности всех групп тулбара
  * @since 5.0.0.4104
  * @param {object} jToolBar jquery объект контейнера тулбара
  * @function Core.toolBars.main.getToolbarWidth
  */
  global.getToolbarWidth = function (jToolBar) {
    global.toolbarWidth = 0;
    jToolBar.find('.toolbar_group, .toolbar_separator').each(function () {
      global.toolbarWidth += $(this).outerWidth(true);
    });
    return global.toolbarWidth;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Сворачивание и разворачивание групп кнопок, в зависимости от размеров окна и их приоритета.
  * @since 5.0.0.4104
  * @function Core.toolBars.main.groupToolbarItems
  */
  global.groupToolbarItems = function () {
    var group;
    var jToolBar = $('#toolbar_container');
    var toolbarWidth = global.getToolbarWidth(jToolBar);
    var objectListWidth = global.getObjectListWidth(jToolBar);
    var jGroups = $('.toolbar_group', jToolBar);

    // Сортируем группы по увеличению приоритета
    jGroups.sort(function (a, b) {
      // Без приоритета будут последними.
      return (parseInt(a.getAttribute("priority") || Number.MAX_SAFE_INTEGER) - parseInt(b.getAttribute("priority") || Number.MAX_SAFE_INTEGER));
    });

    if (jGroups.length > 0 && WA.ToolBarInit.state() === "resolved") {
      if (objectListWidth < toolbarWidth) {
        //Сворачиваем
        for (var i = 0; i < jGroups.length; i++) {
          group = WA.CR.toolBar.groups[jGroups.eq(i).attr("name")];
          var stop = true;
          do {
            stop = group.fold(GROUP_FOLD_MODE.AUTO);
            objectListWidth = global.getObjectListWidth(jToolBar);
            toolbarWidth = global.getToolbarWidth(jToolBar);
          } while (stop && objectListWidth < toolbarWidth);
        };
      } else {
        //Разворачиваем
        var i = jGroups.length - 1;
        for (i; i >= 0; i--) {
          group = WA.CR.toolBar.groups[jGroups.eq(i).attr("name")];
          var stop = true;
          do {
            stop = group.unfold(GROUP_FOLD_MODE.AUTO);
            objectListWidth = global.getObjectListWidth(jToolBar);
            toolbarWidth = global.getToolbarWidth(jToolBar);
            while (objectListWidth < toolbarWidth) {
              group.fold(GROUP_FOLD_MODE.AUTO);
              break;
            }
          } while (stop && objectListWidth > toolbarWidth);
        };
      };
      setRealHeightAndWidth();
    };
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Активирует кнопку тулбара, если в списке объектов выделено только [count] записей.
  * @since 5.0.0.4200
  * @function Core.toolBars.main.enableButtonOnItemsSelect
  */
  global.enableButtonOnItemsSelect = function (toolItem, count) {
    $.when(WA.ObjectListInit).done(function () {
      WA.current.objectList
        .bind('onSelect', function (last, allItems) {
          if (allItems.length === count) toolItem.enable();
          else toolItem.disable();
        })
        .bind("onChange", function (selectedItems, allItems) {
          if (selectedItems.length === count) toolItem.enable();
          else toolItem.disable();
        });
    });

    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Активирует кнопку тулбара, если в списке объектов выделена более count записей.
  * @since 5.0.0.4200
  * @function Core.toolBars.main.enableButtonOnItemsSelectGt
  */
  global.enableButtonOnItemsSelectGt = function (toolItem, count) {
    $.when(WA.ObjectListInit).done(function () {
      WA.current.objectList
        .bind('onSelect', function (last, allItems) {
          if (allItems.length > count) toolItem.enable();
          else toolItem.disable();
        })
        .bind("onChange", function (selectedItems, allItems) {
          if (selectedItems.length > count) toolItem.enable();
          else toolItem.disable();
        });
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Активирует галочку выделения всех записей,
  * если в списке объектов выделена более count записей.
  * @since 5.0.0.4200
  * @function Core.toolBars.main.enableCheckBoxOnItemsSelect
  */
  global.enableCheckBoxOnItemsSelect = function () {
    var jCheckAll = $('#chkAll');
    $.when(WA.ObjectListInit).done(function () {
      WA.current.objectList.bind('onSelect', function (last, allItems) {
        if (allItems.length > 0) jCheckAll.prop('checked', true);
        else jCheckAll.prop('checked', false);
      });
    });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Выполняет действие callback для первого веделенного элемента.
  * @since 5.0.0.4200
  * @function Core.toolBars.main.processFirstSelectedItem
  */
  global.processFirstSelectedItem = function (callback) {
    var items = WA.CR.objectList.getSelectedItems();
    if (items.length > 0) {
      var item = items[0];
      if ($.isFunction(callback)) callback.call(this, { id: item.id, kind: item.kind, refcode: item.referenceCode });
    };
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Выполняет действие callback для текущего открытого объекта.
  * @since 5.0.0.4216
  * @function Core.toolBars.main.processCurrentObject
  */
  global.processCurrentObject = function (callback) {
    // Находимся в карточке.
    var kind = WA.CR.getKind();
    if (!!kind && $.isFunction(callback)) {
      callback.call(this, {
        id: WA.CR.getID(),
        kind: kind,
        refcode: WA.CR.getReferenceCode()
      });
    };
  },
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Активирует кнопку "Открыть карточку" и меняет название группы "Объект".
  * @since 5.0.0.4219
  * @function Core.toolBars.main.enableObjectCardBtn
  */
  global.enableObjectCardBtn = function (toolItem) {
    if (toolItem.groupName === 'TOOLBAR_ACTIONS_WITH_OBJECT_GROUP') {
      $.when(WA.ToolBarInit).done(function () {
        var mode = GetParamInURL('mode').toLowerCase();
        if (mode == 'search') {
          var searchName = GetParamInURL('searchname').toLowerCase();
          var groupName;
          switch (searchName) {
            case 'srchdoc': groupName = 'TOOLBAR_ACTIONS_WITH_DOCUMENT_GROUP'; break;
            case 'srchjob': groupName = 'TOOLBAR_ACTIONS_WITH_JOB_GROUP'; break;
            case 'srchtask': groupName = 'TOOLBAR_ACTIONS_WITH_TASK_GROUP'; break;
            default: groupName = 'TOOLBAR_ACTIONS_WITH_OBJECT_GROUP';
          }
        } else if (mode == 'attachedtotask') {
          groupName = 'TOOLBAR_ACTIONS_WITH_TASK_GROUP';
        } else {
          groupName = 'TOOLBAR_ACTIONS_WITH_OBJECT_GROUP';
        }
        WA.current.toolBar.groups.TOOLBAR_ACTIONS_WITH_OBJECT_GROUP.setLabel(L(groupName));
      });
    }
    return global.enableButtonOnItemsSelect(toolItem, 1);
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


  /**
  * Выполняет действие "Открыть карточку".
  * @since 5.0.0.4200
  * @function Core.toolBars.main.openObjectCard
  */
  global.openObjectCard = function () {
    Core.toolBars.main.processFirstSelectedItem(ShowObjectCard);
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
 * Выполняет действие "Копировать объект".
 * @since 5.0.0.4200
 * @function Core.toolBars.main.copyObject
 */
  global.copyObject = function () {
    Core.toolBars.main.processFirstSelectedItem(function (proxy) {
      switch (proxy.kind.toLowerCase()) {
        case 'edoc':
          proxy.tr = $('#' + proxy.id);
          EDocument(proxy).CopyDoc();
          break;
        case 'ref':
          Reference_CopyRecord(proxy.refcode, proxy.id)
          break;
        default:
          ShowError(L('ERR_UNSUPPORTED_METHOD'));
      }
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Активирует кнопку, если выбран документ или запись справочника (используется для кнопок "Копировать объект" и "Связанные документы").
  * @since 5.0.0.4207
  * @function Core.toolBars.main.enableButtonForDocOrRefRecord
  */
  global.enableButtonForDocOrRefRecord = function (toolItem) {
    $.when(WA.ObjectListInit).done(function () {
      WA.current.objectList.bind('onSelect', function (last, allItems) {
        if (allItems.length === 1) {
          Core.toolBars.main.processFirstSelectedItem(function (proxy) {
            var kindLowered = proxy.kind.toLowerCase();
            // Копирвоание обеъекта работает только для документа и записи справочника.
            if (kindLowered === 'edoc' || kindLowered === 'ref') {
              toolItem.enable();
            } else {
              toolItem.disable();
            }
          });
        } else {
          toolItem.disable();
        }
      });
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Выполняет действие "История".
  * @since 5.0.0.4200
  * @function Core.toolBars.main.openObjectHistory
  */
  global.openObjectHistory = function () {
    Core.toolBars.main.processFirstSelectedItem(function (proxy) {
      ShowObjectCard(proxy, 'view=History&mode=read');
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Выполняет действие "Вложено в задачи".
  * @since 5.0.0.4200
  * @function Core.toolBars.main.showAttachedToTasks
  */
  global.showAttachedToTasks = function () {
    Core.toolBars.main.processFirstSelectedItem(function (proxy) {
      var lowerKind = proxy.kind.toLowerCase();
      if (lowerKind === 'edoc' || lowerKind === 'ref') {
        // Открываем в карточке.
        ShowObjectCard(proxy, 'view=AttachedTasks');
      } else {
        //Открывается в проводнике.
        ShowAttachedToTasks(proxy);
      };
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Выполняет действие "Находится в папках".
  * @since 5.0.0.4200
  * @function Core.toolBars.main.showInsideFolders
  */
  global.showInsideFolders = function () {
    Core.toolBars.main.processFirstSelectedItem(function (proxy) {
      var lowerKind = proxy.kind.toLowerCase();
      if (lowerKind === 'edoc') {
        // Открываем в карточке.
        ShowObjectCard(proxy, 'view=PlacedInFolders');
      } else {
        //Открывается в проводнике.
        ShowInsideFolders(proxy);
      };
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Выполняет действие "Связанные документы".
  * @since 5.0.0.4207
  * @function Core.toolBars.main.showBoundDocuments
  */
  global.showBoundDocuments = function () {
    Core.toolBars.main.processFirstSelectedItem(function (proxy) {
      ShowObjectCard(proxy, 'view=BoundDocuments')
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Выполняет действие "Связанные документы".
  * @since 5.0.0.4207
  * @function Core.toolBars.main.showBoundDocuments
  */
  global.showBoundDocuments = function () {
    Core.toolBars.main.processFirstSelectedItem(function (proxy) {
      ShowObjectCard(proxy, 'view=BoundDocuments')
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Отправляет объект proxy вложением.
  * @since 5.0.0.4200
  * @function Core.toolBars.main.sendAsAttachment
  */
  global.sendAsAttachment = function (proxy) {
    window.WA.services.task.createTaskWithAttachments([{ 'ID': proxy.id, 'Kind': proxy.kind, 'CompCode': proxy.refcode }]).success(function (res) {
      window.open("Task.aspx?view=Card&mode=edit&id=" + res, "task" + res);
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Открывает содержимое папки, переданной в виде прокси объекта.
  * @since 5.2.0.2006
  * @function Core.toolBars.main.openFolderContent
  */
  global.openFolderContent = function (proxy) {
    if (proxy.kind == 'FOL') {
      var folderContentUrl = "";
      if (!$.isEmptyObject(WA.EXT))
        folderContentUrl = "explorer.aspx?ext=" + WA.EXT.current.name + "&ID=" + proxy.id;
      else
        folderContentUrl = "explorer.aspx?ID=" + proxy.id;
      window.open(folderContentUrl);
    }
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Проверяет находимся ли мы в режиме поиска в проводнике или нет.
  * @since 5.0.0.4206
  * @function Core.toolBars.main.isSearchMode
  */
  global.isSearchMode = function () {
    var mode = GetParamInURL('mode').toLowerCase();
    return (mode == 'search' || mode === 'placedin' || mode === 'attachedtotask' || mode == "lastobjects");
  };

  /**
  * Проверяет находимся ли мы в режиме интегрированного поиска (поиск по связи с объектом) в проводнике или нет.
  * @since 5.0.0.4206
  * @function Core.toolBars.main.isIntegratedSearchMode
  */
  global.isIntegratedSearchMode = function () {
    var mode = GetParamInURL('mode').toLowerCase();
    return (mode === 'placedin' || mode === 'attachedtotask');
  };

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Проверяет выделен ли объект во втором уровне иерархии?
  * @since 5.0.0.4212
  */
  var isSelectedSecondLevelInRelationTree = function () {
    if (WA.ObjectListInit.state() === "resolved" && !!WA.CR.objectList) {
      var items = WA.current.objectList.getSelectedItems();
      for (var i = 0; i < items.length; i++) {
        if (items[i]._jObject.parents('.SubBounds').length > 0) {
          return true;
        }
      }
    }
    return false;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Активирует кнопки "Вырезать ссылки" и "Удалить ссылки".
  * @since 5.0.0.4203
  * @function Core.toolBars.main.enableCutAndDeleteLinksBtn
  */
  global.enableCutAndDeleteLinksBtn = function (toolItem) {
    $.when(WA.ObjectListInit).done(function () {
      WA.current.objectList.bind('onSelect', function (last, allItems) {
        if (!global.isSearchMode() && allItems.length > 0 && !isSelectedSecondLevelInRelationTree()) {
          toolItem.enable();
        } else {
          toolItem.disable();
        }
      });
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Активирует/деактивирует кнопку "Вставить ссылки" при наступлении события смены папки.
  * @since 5.5.0.9067
  * @function Core.toolBars.main.enablePasteLinksBtnOnFolderChange
  */
  global.enablePasteLinksBtnOnFolderChange = function (toolItem) {
    WA.current.objectList.bind('onChange', function () {
      Core.toolBars.main.enablePasteLinksBtn(this);
    }, toolItem);
    Core.toolBars.main.enablePasteLinksBtn(toolItem);
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Активирует/деактивирует кнопку "Вставить ссылки".
  * @since 5.0.0.4203
  * @function Core.toolBars.main.enablePasteLinksBtn
  */
  global.enablePasteLinksBtn = function (toolItem) {
    var isSearch = global.isSearchMode();
    var currFolIsReadolny = $('#CurrentFolderIsReadonlyRights').val() === 'True';
    if (isSearch || currFolIsReadolny) {
      toolItem.disable();
    } else {
      toolItem.enable();
    }
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Действие на кнопку "Вставить ссылки" во вкладке "Связанные документы".
  * @since 5.0.0.4216
  * @function Core.toolBars.main.pasteBoundsInTab
  */
  global.pasteBoundsInTab = function (toolItem) {
    var id = WA.current.getID();

    if (WA.getLocation() == "doc") {
      PasteLinks('EDOCUMENT', '' + id);
    } else if (WA.getLocation() == "reference") {
      BindToRecord('' + id, WA.current.getReferenceCode());
    }

    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Действие на кнопку "Удалить ссылки" во вкладке "Связанные документы".
  * @since 5.0.0.4216
  * @function Core.toolBars.main.deleteBoundsInTab
  */
  global.deleteBoundsInTab = function (toolItem) {
    var id = WA.current.getID();

    if (WA.getLocation() == "doc") {
      DeleteLinks('&amp;docid=' + id);
    } else if (WA.getLocation() == "reference") {
      UnBindFromRecord('' + id, WA.current.getReferenceCode());
    }

    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Делает не активной кнопку "Отправить задачей", если открыта папка "Ярлыки".
  * @since 5.1.0.1518
  * @function Core.toolBars.main.enableSendAsTaskAttachment
  */
  global.enableSendAsTaskAttachment = function (toolItem) {
    if (WA.CR.getKind() === 'FOL' && WA.CR.FolderType === FOLDER_TYPE.SHORTCUTS) {
      toolItem.disable();
    } else {
      toolItem.enable();
    };
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Действие на кнопку "Создать и вложить" в карточках ЗЗУ.
  * @since 5.1.0.1522
  * @function Core.toolBars.main.createAndAttach
  */
  global.createAndAttach = function () {
    var popup;
    var dialog = new WA.CMP.dialogs.CreateDocument();
    dialog.bind('loaded', function (data) {
      // Изменяем имя папки за имя ЗЗУ, в которую будет вставлен документ.
      $('#pasteInLabel').text(L('ATTACH_IN'));
      $('#new_txtFolder').text($('.card-header__label').text().trunc(50));
    });
    dialog.bind('ok', function (data) {
      var pleaseWait = new WA.URL('/PleaseWait.aspx');
      pleaseWait.setParam('message', L('PLEASE_WAIT_EDOCUMENT'));
      var rnd = Math.floor(Math.random() * 10000).toString();
      popup = pleaseWait.open('wnd' + rnd);
    });
    dialog.bind('create', function (document) {
      var docUrl = document.toURL();
      docUrl.setParam('mode', 'new');
      docUrl.setParam('cwid', WA.CR.ID);
      docUrl.setParam('cwtype', WA.getLocation());
      docUrl.openIn(popup);
    });
    dialog.bind('error', function (message) {
      popup.close();
    })
    dialog.show()

    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Активирует кнопку тулбара, если в списке объектов выделена хотя бы она запись с заданным типом.
  * @since 5.5.0.9000
  * @function Core.toolBars.main.enableButtonOnJobSelected
  */
  global.enableButtonOnObjectTypeSelected = function (toolItem, type) {
    $.when(WA.ObjectListInit).done(function () {
      WA.current.objectList
        .bind('onSelect', function (last, allItems) {
          var objects = allItems.filter(function (value) { return value.kind === type });
          if (objects.length > 0 && objects.length === allItems.length) {
            toolItem.enable();
          }
          else
            toolItem.disable();
        })
        .bind("onChange", function (selectedItems, allItems) {
          var objects = selectedItems.filter(function (value) { return value.kind === type });
          if (objects.length > 0 && objects.length === allItems.length) {
            toolItem.enable();
          }
          else
            toolItem.disable();
        });
    });
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.Core.toolBars.main);
